"use strict";
const _ = require('lodash');
const { roles } = require('./user.const');
const hasAtLeastSubscriptionLevel = (sessionUser, requiredSubscriptionLevel) => {
    const userSubscriptionLevel = _.get(sessionUser, 'organization.subscriptionLevel');
    switch (requiredSubscriptionLevel) {
        case 'basic':
            return userSubscriptionLevel === 'basic';
        case 'flaivy':
            return (userSubscriptionLevel === 'flaivy' ||
                userSubscriptionLevel === 'flaivyplus' ||
                userSubscriptionLevel === 'enterprise');
        case 'flaivyplus':
            return (userSubscriptionLevel === 'flaivyplus' ||
                userSubscriptionLevel === 'enterprise');
        case 'enterprise':
            return userSubscriptionLevel === 'enterprise';
        default:
            return false;
    }
};
const isSuper = sessionUser => _.includes(sessionUser.roles, roles.super);
const isSupplierRoleWithOrderAccess = sessionUser => {
    const supplierRolesWithOrderAccess = [
        roles.supplier,
        roles.qvantiSupplierRoleOrderAcceptance,
    ];
    return _.some(supplierRolesWithOrderAccess, x => _.includes(sessionUser.roles, x));
};
module.exports = {
    hasAtLeastSubscriptionLevel,
    isSuper,
    isSupplierRoleWithOrderAccess,
};
